import { MODAL_ACTIONS } from '@common/constants';
import {
  isArray,
  isBoolean,
  isNumber,
  isDate,
  isObject,
  isString,
  isNull,
  get,
} from 'lodash';

const createPathNameForTextCheckbox = (modalShowState, propKey) => {
  debugger;
  return modalShowState.listSource && modalShowState.parent
    ? 'item.' + `${modalShowState.parent}.` + propKey // eslint-disable-line
    : modalShowState.listSource
    ? 'item.' + propKey // eslint-disable-line
    : modalShowState.parent
    ? modalShowState.parent + '.' + propKey // eslint-disable-line
    : propKey; // eslint-disable-line
};

const createPathNameForCheckbox = (modalShowState, propKey) => {
  const path = modalShowState?.parent
    ? modalShowState.parent + '.' + propKey // eslint-disable-line
    : propKey; // eslint-disable-line

  return path;
};

const isNodeList = (currentField, modalShowState, propKey) => {
  return isArray(currentField) && propKey === modalShowState.listSource;
};

const isNodeObj = (currentField, modalShowState) => {
  return (
    isObject(currentField) &&
    !isArray(currentField) &&
    modalShowState.showRootFields
  );
};

const isListSourceNotSelected = (objKeys, modalShowState) => {
  return (
    !objKeys.includes(modalShowState.listSource) &&
    !modalShowState.showRootFields
  );
};

const isArrayWithSelectedSource = (currentField, modalShowState, propKey) => {
  return (
    isArray(currentField) &&
    propKey === modalShowState.listSrc &&
    modalShowState.parent !== '' &&
    modalShowState.showRootFields
  );
};

const isFieldActualPlaceholder = (currentField, modalShowState) => {
  return (
    (isString(currentField) ||
      isNumber(currentField) ||
      isDate(currentField) ||
      isNull(currentField) ||
      isBoolean(currentField)) &&
    modalShowState.showRootFields
  );
};

const getShowStateForArrayWithSource = ({ modalShowState, propKey }) => {
  return {
    ...modalShowState,
    parent: `${
      modalShowState?.parent ? modalShowState.parent + '.' : ''
    }${propKey}`,
    showRootFields: true,
  };
};

const getShowStateForList = (modalShowState) => {
  return {
    ...modalShowState,
    parent: '',
    showRootFields: true,
  };
};

const getShowStateForNodeObj = ({ propKey, modalShowState }) => {
  let validPropKey = getValidPropKeyForNodeObj(propKey);
  let parentPath = getParentPathForNodeObj({
    propKey,
    modalShowState,
  });

  return {
    ...modalShowState,
    parent: `${parentPath}${validPropKey}`,
    showRootFields: true,
  };
};

const getValidPropKeyForNodeObj = (propKey) => {
  return isNaN(propKey) ? propKey : `[${propKey}]`;
};

const getParentPathForNodeObj = ({ modalShowState, propKey }) => {
  if (!modalShowState?.parent) return '';
  const parentPath = isNaN(propKey)
    ? modalShowState.parent + '.'
    : modalShowState.parent;

  return parentPath;
};

const getModalAction = (showModal) => {
  return get(showModal, 'action');
};

const isShowModalCalcAction = (showModal) => {
  const modalAction = getModalAction(showModal);
  return modalAction === MODAL_ACTIONS.CALC;
};

const isShowModalSumAction = (showModal) => {
  const modalAction = getModalAction(showModal);
  return modalAction === MODAL_ACTIONS.SUM;
};

const isModalCalcOrSum = (showModal) => {
  const modalAction = getModalAction(showModal);
  return (
    modalAction === MODAL_ACTIONS.CALC || modalAction === MODAL_ACTIONS.SUM
  );
};

export {
  getModalAction,
  isShowModalCalcAction,
  isShowModalSumAction,
  isModalCalcOrSum,
  createPathNameForCheckbox,
  isNodeList,
  isNodeObj,
  isListSourceNotSelected,
  isArrayWithSelectedSource,
  isFieldActualPlaceholder,
  getShowStateForArrayWithSource,
  getShowStateForList,
  getShowStateForNodeObj,
  getValidPropKeyForNodeObj,
  getParentPathForNodeObj,
  createPathNameForTextCheckbox,
};
